export const DEFAULT_CRATE_CUBE = 4;
